export default __webpack_public_path__ + "media/images/sort_asc-9326ad44ae4bebdedd141e7a53c2a730.png";